module.exports = __webpack_public_path__ + "img/confused.54a94bdf.svg";